/**
 * Whitespace-delimited tokens, the backend's `len(text.split())` — the unit the word
 * allowance is measured in. Counts without materialising the token array.
 */
export const countWords = (text: string): number => {
    const re = /\S+/g;
    let n = 0;
    while (re.exec(text) !== null) n++;
    return n;
};

/**
 * The largest prefix of `text` holding at most `n` words (same tokenization as countWords),
 * sliced from the original so formatting is preserved. Fewer words → the whole text.
 */
export const firstNWords = (text: string, n: number): string => {
    if (n <= 0) return '';
    const re = /\S+/g;
    let count = 0, m: RegExpExecArray | null;
    while ((m = re.exec(text)) !== null) {
        if (++count === n) return text.slice(0, m.index + m[0].length);
    }
    return text;
};

// No word runs longer: a prefix that would have to back off further (CJK, a long URL) is cut hard.
const MAX_WORD_CHARS = 100;

/**
 * The largest prefix of `text` of at most `n` characters that does not end mid-word, nor in the
 * whitespace before the next one — the rest then starts with it, and the backend's trimming of
 * the prefix cannot glue the two halves together.
 */
export const firstNChars = (text: string, n: number): string => {
    if (text.length <= n) return text;
    let end = n;
    if (!/\s/.test(text[n])) {
        const floor = Math.max(0, n - MAX_WORD_CHARS);
        while (end > floor && !/\s/.test(text[end - 1])) end--;
        if (end === floor && !/\s/.test(text[floor - 1] ?? '')) end = n;
    }
    while (end > 0 && /\s/.test(text[end - 1])) end--;
    return text.slice(0, end);
};
